import React, { ReactNode } from 'react';
import { Options } from 'react-overlays/usePopper';
import { SIZES } from '../../fundamentals/sizes/sizes';
import { IAllowBodyStyleOverrideProps } from '../../common/interfaces';
import { IModalProps } from '../Modal/Modal';
import { UsePopperOptions } from 'react-overlays/usePopper';
import { MediaSize } from '../../fundamentals/sizes/mediaSize';

export type TourModalSize = typeof SIZES.X_SMALL | typeof SIZES.SMALL | typeof SIZES.MEDIUM | typeof SIZES.LARGE;

export type TourLocale = {
  back?: string;
  last?: string;
  next?: string;
  pagerSeparator?: string;
};

export const defaultTourLocale = { back: `Back`, next: `Next`, pagerSeparator: `of`, last: `Finish` };

// Note: passing onShow will cancel removeBodyOverflow fnCall,
// call `removeBodyOverflow` to remove overflow added by react-modal if not need
export interface IStepConfig extends IAllowBodyStyleOverrideProps, Pick<IModalProps, 'closable' | 'blur'> {
  dismissible?: boolean;
  size?: TourModalSize;
  hideCloseButton?: boolean;
  anchored?: boolean;
  overlay?: boolean;
  hidePager?: boolean;
  placement?: Options['placement'];
  locale?: TourLocale;
  asModal?: boolean;
}

export interface IStep extends IStepConfig {
  image?: string; // Note: should support video in the next iteration
  imageAlt?: string;
  mediaSize?: MediaSize;
  onImageClick?: React.MouseEventHandler;
  body?: string | ReactNode;
  target: string | HTMLElement;
  title?: string;
  addBg?: boolean;
  scrollToTop?: boolean;
}

// https://github.com/gilbarbara/react-joyride/tree/88853fea5d5940ae5e71dc81681406102dceef50/src/constants

export enum EVENTS {
  TOUR_START = 'tour:start',
  TOUR_END = 'tour:end',
  TOUR_CLOSE = 'tour:close',
  STEP_BEFORE = 'step:before',
  STEP_AFTER = 'step:after',
  ERROR_TARGET_NOT_FOUND = 'tour:error_target_not_found'
}

export const MODIFIERS_VERT: UsePopperOptions['modifiers'] = [
  {
    name: 'offset',
    options: {
      offset: [0, 0]
    }
  },
  {
    name: 'arrow',
    options: {
      padding: 8 // px from the edges of the popper
    }
  },
  {
    name: 'preventOverflow',
    options: {
      padding: 16
    }
  }
];

export const MODIFIERS_HORIZ: UsePopperOptions['modifiers'] = [
  {
    name: 'offset',
    options: {
      offset: [0, 0]
    }
  },
  {
    name: 'arrow',
    options: {
      padding: 16 // px from the edges of the popper
    }
  },
  {
    name: 'preventOverflow',
    options: {
      padding: 16
    }
  }
];
